import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import FormHelperText from '@anm/components/form/FormHelperText';
import { EmailField } from '@anm/components/form/fields';
import isUserExist from '@anm/helpers/is/isUserExist';
import { Config as FinalFormConfig } from 'final-form';
import memoize from 'lodash/fp/memoize';
import React, { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { compose, mapProps } from 'recompose';

import withEmailFromUrl from '../../../../HOCs/withEmailFromUrl';
import { submitFormHelpers } from '../../SubmitForm';
import { RecoveryFormWrapper } from '../RecoveryContainer';

type RecoveryFormOwnProps = FinalFormConfig & {};

type RecoveryFormProps = RecoveryFormOwnProps & HOCs & {};

type HOCs = {
  initialData: RecoveryFormInitialData;
};

type RecoveryFormInitialData = {
  email?: string;
};

const isUserExistMemoize = memoize(isUserExist);

const checkIfUserExist = async (email: string) =>
  !(await isUserExistMemoize(email)) ? 'User not found' : null;

const renderForm = ({
  submitting,
  submitErrors,
  handleSubmit
}: FormRenderProps) => (
  <RecoveryFormWrapper onSubmit={handleSubmit}>
    <EmailField />
    {submitErrors && (
      <FormHelperText variant="belowField">{submitErrors}</FormHelperText>
    )}
    <ButtonLoader
      type="submit"
      size="full-width"
      variant="light-blue-lowercase"
      isPending={submitting}
    >
      Reset password
    </ButtonLoader>
  </RecoveryFormWrapper>
);

const validateForm = submitFormHelpers.validateForm({
  email: checkIfUserExist
});

const RecoveryForm: FC<RecoveryFormProps> = ({
  initialData,
  ...otherProps
}) => (
  <Form
    render={renderForm}
    validate={validateForm}
    initialValues={initialData}
    {...otherProps}
  />
);

export default compose<HOCs, RecoveryFormOwnProps>(
  withEmailFromUrl,
  mapProps(({ emailFromUrl, ...otherProps }) => ({
    initialData: { email: emailFromUrl },
    ...otherProps
  }))
)(RecoveryForm);
